export const BREAKPOINTS = {
  sm: { min: 0, max: 47.99, uom: 'rem' },
  md: { min: 48, max: 64, uom: 'rem' },
  lg: { min: 64.01, uom: 'rem' }
} as const
